import { gql } from '../../api/graphql';

export type ActivationField =
    | 'yms'
    | 'rtls'
    | 'empty_drop_enabled'
    | 'workflow_kiosks_active'
    | 'require_zone_destination';

const ACTIVATION_MUTATIONS: Record<ActivationField, { mutation: string; returnFields: string }> = {
    yms: {
        mutation: 'set_yms_enabled',
        returnFields: 'yms empty_drop_enabled',
    },
    rtls: {
        mutation: 'set_rtls_enabled',
        returnFields: 'rtls',
    },
    empty_drop_enabled: {
        mutation: 'set_empty_drop_enabled',
        returnFields: 'yms empty_drop_enabled',
    },
    workflow_kiosks_active: {
        mutation: 'set_workflow_kiosks_active',
        returnFields: 'workflow_kiosks_active',
    },
    require_zone_destination: {
        mutation: 'set_require_zone_destination',
        returnFields: 'require_zone_destination',
    },
};

export type ActivationResult = Partial<Record<ActivationField, boolean>>;

export async function toggleActivation(
    facilityId: number,
    field: ActivationField,
    enabled: boolean,
): Promise<ActivationResult> {
    const { mutation, returnFields } = ACTIVATION_MUTATIONS[field];

    const query = `
        mutation Toggle($facilityId: Int!, $enabled: Boolean!) {
            ${mutation}(facility_id: $facilityId, enabled: $enabled) {
                uuid
                facility_id
                ${returnFields}
            }
        }
    `;

    const data = await gql(query, { facilityId, enabled });
    return data[mutation];
}
